import { render, staticRenderFns } from "./PremiumBadge.vue?vue&type=template&id=245d3f78"
import script from "./PremiumBadge.vue?vue&type=script&lang=js"
export * from "./PremiumBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports